import { SortableContext, useSortable } from '@dnd-kit/sortable'

import { CSS } from '@dnd-kit/utilities'

import { useMemo } from 'react'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

import { Column, Task, TaskStatus } from '../types/OrderElements.types'

import TaskCard from './TaskCard'

interface Props {
  column: Column
  tasks: Task[]
  containerId: number
}

function ColumnContainer({ column, tasks, containerId }: Props): React.ReactElement {
  const tasksIds = useMemo(() => {
    return tasks.map((task) => task.id)
  }, [tasks])

  const { setNodeRef, transform, transition } = useSortable({
    id: containerId,
    data: {
      type: 'Column',
      column,
    },
    disabled: false,
  })

  const style = {
    transition,
    transform: CSS.Transform.toString(transform),
  }
  const mediaQuery = [{ screen: '(min-width: 280px)', width: '160px' }]

  return (
    <div>
      <div className="bg-white rounded h-18 md:h-24 w-18 md:w-24 border-purple border-4" ref={setNodeRef} style={style}>
        <SortableContext items={tasksIds}>
          {tasks.map((task) => (
            <div key={task.id}>
              {task.check && (
                <ResponsiveImage
                  height={50}
                  imageClassName="w-12 absolute ml-2 md:ml-5 -mt-14"
                  imageWidths="160"
                  mediaQuery={mediaQuery}
                  srcKey={
                    task.taskStatus === TaskStatus.Right
                      ? 'bootcamp/activities/orderElement/Right.png'
                      : 'bootcamp/activities/orderElement/wrong.png'
                  }
                />
              )}
              <TaskCard key={task.id} task={task} />
            </div>
          ))}
        </SortableContext>
      </div>
    </div>
  )
}

export default ColumnContainer
